import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDioApproverNewHireCoverageEnrollment, getNewHireCoverageEnrollment } from '../../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { setCoverageFormError, setNewHireEnrollmentCoverage } from '../slice/new-hire-enrollment-slices';
import { getPendingEnrollmentLocalStorage } from '../member/benefit-enrollment/helper/diocese-approver-coverage-helper';
import { CoverageLoadErrorMessage } from '../../../constants/constant-strings';


export function useNewHireEnrollmentCoverage(employeeId: string, employerId: string, queryString: string, isDioApprover: boolean, eventType: string) {
	const localStoragePendingEnrollment = getPendingEnrollmentLocalStorage();
	const loaded = useSelector<TcsmStates, boolean>(state => state.newHireEnrollmentState?.newHireCoverageLoaded);
	const formID = useSelector<TcsmStates, number>(state => state.newHireEnrollmentState?.dioApproverCurrentFormId ?? localStoragePendingEnrollment?.id);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!loaded) {
			const handleSuccess = (response) => {
				// Check if response contains an error status
				if (response?.data?.status?.code === 'ERROR') {
					dispatch(setCoverageFormError(CoverageLoadErrorMessage));
				} else {
					dispatch(setNewHireEnrollmentCoverage(response?.data));
				}
			};

			const handleFailure = () => dispatch(setCoverageFormError(CoverageLoadErrorMessage));

			if (isDioApprover) {
				dispatch(getDioApproverNewHireCoverageEnrollment(
					employeeId ?? localStoragePendingEnrollment?.employee?.guid,
					formID,
					handleSuccess,
					handleFailure,
				));
			} else {
				dispatch(getNewHireCoverageEnrollment(
					employeeId,
					queryString,
					employerId,
					eventType,
					handleSuccess,
					handleFailure,
				));
			}
		}
	}, [employerId]);

	return loaded;
}